import { useState } from 'react'
import type { FormEvent } from 'react'
import { api } from '../lib/api'
import { errorText } from '../components/Toaster'
import { Button, Input, Notice } from '../ds'

export function AuthScreen({ onAuthed }: { onAuthed: () => void }) {
  const [step, setStep] = useState<'email' | 'code'>('email')
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    setError('')
    setLoading(true)
    try {
      if (step === 'email') {
        await api.requestCode(email.trim())
        setStep('code')
      } else {
        await api.verifyCode(email.trim(), code)
        onAuthed()
      }
    } catch (err) {
      setError(errorText(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="center-screen">
      <section className="card">
        <div className="wordmark">MENTIONS</div>
        <h1>{step === 'email' ? 'Вход' : 'Код подтверждения'}</h1>
        <p className="sub">
          {step === 'email'
            ? 'Войдите по email — пришлём одноразовый код.'
            : `Мы отправили код на ${email}.`}
        </p>
        <form className="auth-form" onSubmit={submit}>
          {error && <Notice>{error}</Notice>}
          {step === 'email' ? (
            <Input
              type="email"
              placeholder="you@mrktng.bz"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              required
            />
          ) : (
            <Input
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="• • • • • •"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              autoFocus
              required
            />
          )}
          <Button type="submit" block disabled={loading || (step === 'code' && code.length < 6)}>
            {loading ? 'Минутку…' : step === 'email' ? 'Получить код' : 'Войти'}
          </Button>
          {step === 'code' && (
            <Button
              type="button"
              variant="ghost"
              onClick={() => {
                setStep('email')
                setCode('')
                setError('')
              }}
            >
              Изменить email
            </Button>
          )}
        </form>
      </section>
    </main>
  )
}
